function EnrolleeCorrelateControl(aEnrollee, aOrganization, aAgent, aTimeZone, aVisit, aCorrelation, aPhoto, aProfile, aAddress) {
    "use strict";

    this.Address = '';
    this.PrimaryId = '';
    this.AgentName = '';
    this.AgentId = '';
    this.Birthdate = '';
    this.EnrolleeName = '';
    this.EnrolleId = '';
    this.Organization = '';
    this.RiskLevel = '';
    this.Supervision = '';
    this.TimeZone = '';
    this.ReferralDate = ''
    this.photoUri = '';
    this.VisitStartDate = '';
    this.VisitEndDate = '';
    this.VisitId = '';
    this.enrolleeCorrelations = [];
    this.EnrollmentDuration = '';
    this.enrolleeRedirectFunction = '';
    this.PhotoUri = 'Images/NoPhoto.png';
    this.PhotoDescription = '';


    if (!isNullOrUndefined(aEnrollee)) {
        this.EnrolleeId = aEnrollee.Id;
        this.PrimaryId = aEnrollee.PrimaryId;
        this.Birthdate = aEnrollee.Birthdate;
        this.EnrolleeName = aEnrollee.FullName;
        this.Supervision = EnrolleeAssignedFormatter(aEnrollee.IsAssigned);
        this.RiskLevel = EnrolleeRiskLevelFormatter(aEnrollee.RiskLevelId);
        if (!isNaN(aEnrollee.ReferralDate.getTime()) && aEnrollee.ReferralDate.getFullYear() != 0) {
            this.ReferralDate = DisplaySuperShortDate(aEnrollee.ReferralDate);
        }

        this.enrolleeRedirectFunction = 'onEnrolleeCorrelationClick(' + aEnrollee.Id + ');';

    }

    if (!isNullOrUndefined(aOrganization)) {
        this.Organization = aOrganization.Name;
    }

    if (!isNullOrUndefined(aAgent)) {
        this.AgentName = aAgent.FullName;
        this.AgentId = aAgent.Id;
    }

    if (!isNullOrUndefined(aTimeZone)) {
        this.TimeZone = localizeDataItem('TimeZone', aTimeZone.Name);
    }
    if (!isNullOrUndefined(aVisit)) {
        this.Address = aVisit.Address;
        this.VisitId = aVisit.Id;

        if (!isNullOrUndefined(aVisit.TrackItem.data.EndDateUTC) && aVisit.TrackItem.data.StartDateUTC) {
            this.VisitStartDate = displayEnrolleeTimeZoneFormatted(aVisit.TrackItem.data.StartDateUTC, aTimeZone);
            this.VisitEndDate = displayEnrolleeTimeZoneFormatted(aVisit.TrackItem.data.EndDateUTC, aTimeZone);
        }//end of if
    }
    if (aAddress) {
        this.Address = aAddress;
    }
    if (!isNullOrUndefined(aCorrelation)) {
        this.enrolleeCorrelations = aCorrelation;
    }

    if (!isNullOrUndefined(aPhoto)) {
        this.PhotoUri = MUGSHOTS + aPhoto.PhotoUri;
    }

    if (!isNullOrUndefined(aPhoto)) {
        this.PhotoDescription = aPhoto.PhotoDescription;
    }

    if (!isNullOrUndefined(aProfile)) {
        this.EnrollmentDuration = dateSelectorFormatter(aProfile.SupervisionBeginDate) + " - " + dateSelectorFormatter(aProfile.SupervisionEndDate);
    }
}
if (typeof exports !== 'undefined') {
    module.exports = EnrolleeCorrelateControl;
}